import { z } from 'zod';

export const ProdutoNcmSchema = z.object({
    descricao: z.string(),
    prn_descricao: z.string(),
    prn_ncm: z.string(),
    prn_tipo: z.string(),
    prn_ultima_alteracao: z.string(),
});
